import { gql } from '@apollo/client'

import { INGREDIENT_SPECIAL_CASE_FRAGMENT } from '../fragments'

const UPDATE_INGREDIENT_SPECIAL_CASE_MUTATION = gql`
  mutation updateIngredientSpecialCase(
    $id: ID!
    $data: IngredientSpecialCaseInput!
  ) {
    updateIngredientSpecialCase(id: $id, data: $data) {
      ...IngredientSpecialCaseFragment
    }
  }
  ${INGREDIENT_SPECIAL_CASE_FRAGMENT}
`

export default UPDATE_INGREDIENT_SPECIAL_CASE_MUTATION
